import { Paper } from '@material-ui/core';
import styled from 'styled-components';

export const WrapperTabela = styled(Paper)`
  padding: 1rem;

  width: 100%;

  display: flex;
  flex-direction: column;

  position: relative;

  .MuiTableContainer-root {
    max-height: ${(props) => props.height};

    ::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }

    ::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.2);
      border-radius: 4px;
    }

    ::-webkit-scrollbar-track {
      background-color: #eaeaea;
    }
  }

  > nav.MuiPagination-root {
    align-self: flex-end;

    margin-top: 1.5rem;
  }
`;

export const WrapperTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  margin-bottom: 2rem;

  > p {
    text-transform: uppercase;

    font-weight: 700;
    font-size: 1.2rem;
  }
`;

export const Loading = styled.div`
  position: absolute;

  top: 0;
  left: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  background: rgba(255, 255, 255, 0.5);

  width: 100%;
  height: 100%;

  z-index: 99;
`;

export const WrapperSearch = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  flex: 1;
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  margin-top: 2rem;

  p {
    font-size: 1.2rem;
    font-weight: 700;

    color: #666;
  }

  span {
    text-transform: uppercase;
  }
`;
